import ShopfloorTouchTerminalPage from "./ShopfloorTouchTerminalPage";

/**
 * Màn hình MES Thống Nhất (MES Machine Workstation & Dispatch Station)
 * Hợp nhất hoàn toàn tuyến /mes và /shopfloor/terminal thành một Trạm Điều Hành Ca Máy duy nhất,
 * kết nối trực tiếp với kế hoạch APS, lệnh sản xuất và đơn hàng.
 */
export default function MesDashboardPage() {
  return <ShopfloorTouchTerminalPage />;
}
